import type { GetTransportResponsiblesResponse } from '@/types/TransportResponsible.ts'

import { apiGet } from './ApiClient'

export async function getTransportResponsibles(): Promise<GetTransportResponsiblesResponse> {
  return await apiGet<GetTransportResponsiblesResponse>('/transport/responsibles')
}
